// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__FlduQ","dialog":"modal_dialog__hR39N","modal":"modal_modal__cxO5j"};